import React from "react";

export default function PaymentFailed() {
  return <div>Payment Failed</div>;
}
